// extracted by mini-css-extract-plugin
export var footer = "_p8-5";
export var fulfillmentInput = "_p8-0";
export var shipDateInput = "_p8-1";
export var shipmentModal = "_p8-2";
export var shipmentModalContent = "_p8-3";
export var tableContainer = "_p8-4";